import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
} from "@carbon/react";

export default function MedicalRecordsChiefComplaint({ patientName, complaint }) {
  if (!complaint) return <p>主訴データがありません。</p>;

  const rows = [
    { label: "最近の嬉しかったこと", value: complaint.you_made_happy },
    { label: "気になる症状（あれば）", value: complaint.concerning_symptoms },
    { label: "その症状の期間", value: complaint.symptoms_duration },
    { label: "不安や質問したいこと", value: complaint.concerns_or_questions },
  ];

  return (
    <div>
      <TableContainer>
        <Table size="sm">
          <TableHead>
            <TableRow>
              <TableHeader>質問</TableHeader>
              <TableHeader>回答</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell>{row.label}</TableCell>
                <TableCell>{row.value || "－"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
